import React, { useEffect, useState } from "react";
import { MDBCol, MDBRow, MDBBtn } from 'mdbreact';
import { getArticleDetails, getNoPidArticles, updateArticleDetails } from "../../helpers/articles";
import { getInstitutionsPercentage, getEnrichmentTypesPercentage, getUnconfirmedInstitutions, confirmInstitution, getNoPidInstitutions, saveInstitutionRor, getNoRinggoldInstitutions } from "../../helpers/institutions";
import {
    PieChart,
    Card,
    ArticleDetailsModal,
    Table,
    Tabs,
    showSuccessToast,
    showErrorToast,
    InstitutionTableCell,
    RinggoldInstitutionTableCell
} from "pubtrack-frontend-library";
import { allFilterOption, dealDefaultFilterOption } from "../../constants";
import { userSettings } from "../../user-settings";
import { getDeals } from "../../helpers/deals";
import { MDBTabPane } from "mdbreact";


const Enrichment = () => {
    const [institutionsPercentage, setInstitutionsPercentage] = useState([]);
    const [typesPercentage, setTypesPercentage] = useState([]);
    const [selectedMessage, setSelectedMessage] = useState(null);
    const [articleDetails, setArticleDetails] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [articles, setArticles] = useState([]);
    const [unconfirmedInstitutions, setUnconfirmedInstitutions] = useState([]);
    const [noPidInstitutions, setNoPidInstitutions] = useState([]);
    const [noRinggoldInstitutions, setNoRinggoldInstitutions] = useState([]);

    const tabs = ["Incomplete articles", "No PID", "Confirmation", "Ringgold mapping"];

    useEffect(() => {
        getInstitutionsPercentage()
            .then(res => setInstitutionsPercentage(res.data));

        getEnrichmentTypesPercentage()
            .then(res => setTypesPercentage(res.data));

        getNoPidArticles()
            .then(res => setArticles(res.data));

        getUnconfirmedInstitutions()
            .then(res => setUnconfirmedInstitutions(res.data));

        getNoPidInstitutions()
            .then(res => setNoPidInstitutions(res.data));

        getNoRinggoldInstitutions()
            .then(res => setNoRinggoldInstitutions(res.data));
    }, []);

    const renderInstitutions = item => {
        return item.institutions.length ?
            item.institutions.map(item => item.name ? item.name : null).join(', ')
            :
            null;
    };

    const renderAuthors = authors => {
        return authors.length ?
            authors.map(item => item.institutions ? renderInstitutions(item) : null)
            :
            "-";
    };

    const columns = React.useMemo(
        () => [
            {
                Header: 'title',
                accessor: 'title',
                sortable: false
            },
            {
                Header: 'No PID',
                id: 'no_pid',
                Cell: ({ row }) =>
                    <span>{renderAuthors(row.original.authors) || "-"}</span>
            },
        ], []
    );

    const unconfirmedInstitutionsColumns = [
        {
            Header: 'institution',
            accessor: 'institution',
            sortable: false
        },
        {
            Header: 'RORID',
            accessor: 'rorid',
            Cell: ({ row }) =>
                <a href={row.original.rorid || row.original.ror} target="_blank" className="link">{row.original.rorid || row.original.ror}</a>
        },
        {
            Header: 'ROR name',
            accessor: 'rorname',
            sortable: false
        },
        {
            Header: '',
            id: 'confirm',
            Cell: ({ row }) =>
                <MDBBtn color="primary" size='sm' onClick={(e) => onConfirmInstitution(e, row)}>confirm</MDBBtn>
        },
    ];

    const noPidInstitutionsColumns = [
        {
            Header: 'institution',
            accessor: 'institution',
        },
        {
            Header: '',
            id: 'confirm',
            Cell: ({ row }) =>
                <InstitutionTableCell
                    row={row.original}
                    saveRor={saveRor}
                />
        }
    ];

    const noRinggoldInstitutionsColumns = [
        {
            Header: 'institution',
            accessor: 'institution',
        },
        {
            Header: 'RORID',
            accessor: 'rorid',
            Cell: ({ row }) =>
                <a href={row.original.rorid || row.original.ror} target="_blank" className="link">{row.original.rorid || row.original.ror}</a>
        },
        {
            Header: 'ringgold',
            id: 'ringgold',
            Cell: ({ row }) =>
                <RinggoldInstitutionTableCell
                    row={row.original}
                    saveRinggold={saveRinggold}
                />
        }
    ];

    const onSelectRow = row => {
        const messageId = row && row.original ? row.original["id"] : null;
        setSelectedMessage(messageId);
    };

    useEffect(() => {
        if (selectedMessage) {
            getArticleDetails(selectedMessage)
                .then(res => setArticleDetails(res.data))
                .then(setIsOpen(true))
                .catch(error => console.log(error))
                .then(setSelectedMessage(null))
        }
    }, [selectedMessage]);

    const addFilterOption = (arr, key, value) => {
        const isPresent = !!arr.find(item => item[key] === value);
        if (!isPresent) {
            switch (key) {
                case "title":
                    arr.unshift(allFilterOption);
                    break;
                case "institution":
                    arr.unshift(dealDefaultFilterOption);
                    break;
                default:
                    break;
            }
        };
        return arr;
    };

    const getDealsFilterData = () => {
        return getDeals()
            .then(res => addFilterOption(res.data, "institution", "N.A."));
    };

    const updateArticle = () => {
        return updateArticleDetails(selectedMessage, articleDetails);
    };

    const removeInstitution = id => {
        const filteredInstitutions = unconfirmedInstitutions.filter(item => item.rorid !== id);
        setUnconfirmedInstitutions(filteredInstitutions);
    };

    const onConfirmInstitution = (e, row) => {
        e.stopPropagation();
        /// TODO change to row.original["id"] in real endpoint
        const institutionId = row && row.original ? row.original["rorid"] : null;

        if (institutionId) {
            confirmInstitution(institutionId)
                .then(res => {
                    /// TODO remove removeInstitution in real endpoint
                    removeInstitution(institutionId);
                    showSuccessToast("Confirmed");
                })
                .catch(error => {
                    showErrorToast("Error");
                });
        };
    };

    const removeNoPidInstitution = id => {
        const filteredInstitutions = noPidInstitutions.filter(item => item.id !== id);
        setNoPidInstitutions(filteredInstitutions);
    };

    const saveRor = async (id, value) => {
        removeNoPidInstitution(id);
        saveInstitutionRor(id, value);
    };

    const removeRinggoldInstitution = id => {
        const filteredInstitutions = noRinggoldInstitutions.filter(item => item.id !== id);
        setNoRinggoldInstitutions(filteredInstitutions);
    };

    const saveRinggold = async (id, value) => {
        removeRinggoldInstitution(id);
        // saveRinggoldInstitution(id, value);
    };


    return (
        <div className="container">
            <MDBRow className="mt-5 d-flex justify-content-center">
                <MDBCol md='3' className="my-4">
                    <Card
                        title="Enriched/not-enriched with RORID:"
                        content={<PieChart data={institutionsPercentage} labelKey="label" valueKey="count" />}
                    />
                </MDBCol>
                <MDBCol md='3' className="my-4">
                    <Card
                        title="Enrichment type:"
                        content={<PieChart data={typesPercentage} labelKey="label" valueKey="count" showInPercentage />}
                    />
                </MDBCol>
            </MDBRow>

            <div className="my-5">
                <Tabs
                    tabs={tabs}
                    content={
                        <>
                            <MDBTabPane tabId="Incomplete articles" role="tabpanel">
                                <Table
                                    data={articles}
                                    columns={columns}
                                    onSelectRow={onSelectRow}
                                    exportBtnDropdown={false}
                                    exportBtnTitle={"Export for Mturk"}
                                    showCount={true}
                                />
                            </MDBTabPane>

                            <MDBTabPane tabId="No PID" role="tabpanel">
                                <Table
                                    data={noPidInstitutions}
                                    columns={noPidInstitutionsColumns}
                                    exportAvailable={true}
                                    onSelectRow={onSelectRow}
                                    exportBtnDropdown={false}
                                    exportBtnTitle={"Export for Mturk"}
                                    showCount={true}
                                />
                            </MDBTabPane>

                            <MDBTabPane tabId="Confirmation" role="tabpanel">
                                <Table
                                    data={unconfirmedInstitutions}
                                    columns={unconfirmedInstitutionsColumns}
                                    exportAvailable={true}
                                    exportBtnDropdown={false}
                                    exportBtnTitle={"Export for Mturk"}
                                    showCount={true}
                                />
                            </MDBTabPane>

                            <MDBTabPane tabId="Ringgold mapping" role="tabpanel">
                                <Table
                                    data={noRinggoldInstitutions}
                                    columns={noRinggoldInstitutionsColumns}
                                    exportAvailable={true}
                                    exportBtnDropdown={false}
                                    exportBtnTitle={"Export for Mturk"}
                                    showCount={true}
                                />
                            </MDBTabPane>
                        </>
                    }
                />
            </div>

            <ArticleDetailsModal
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                articleDetails={articleDetails}
                tabItems={userSettings.details}
                showArticleDeal={true}
                getFilterData={getDealsFilterData}
                updateArticle={updateArticle}
            />
        </div>
    );
};


export default Enrichment;